var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgWarningIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.14856 1.00142L14.4994 12.0014C14.6836 12.3203 14.5743 12.728 14.2554 12.9121C14.1541 12.9706 14.0391 13.0014 13.9221 13.0014H1.22038C0.852191 13.0014 0.553711 12.703 0.553711 12.3348C0.553711 12.2177 0.584518 12.1028 0.643031 12.0014L6.99389 1.00142C7.17796 0.682549 7.58569 0.573303 7.90456 0.757396C8.00589 0.815909 8.09009 0.900069 8.14856 1.00142ZM6.90456 9.6681V11.0014H8.23789V9.6681H6.90456ZM6.90456 5.00142V8.33477H8.23789V5.00142H6.90456Z",
    fill: "#FFC143"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWarningIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/WarningIcon.d25486c6.svg";
export { ForwardRef as ReactComponent };